import React, { useMemo } from 'react';
import { GenericListPage } from '../../../components/generic';
import { usePmsSubComponents, PmsSubComponent } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  const config = useMemo(
    () => ({
      ...moduleConfig,
      getColumns,
      getToolbarIcon,
      getTableActions,
    }),
    [],
  );
  return <GenericListPage<PmsSubComponent> useData={usePmsSubComponents} config={config} />;
};

export default List;
